import styled from 'styled-components'

export const AppBody = styled.div`
  text-align: left;
  background: white;
  color: #2B303A;
`
